<template>
  <div class="container">
    <header>
      <div class="container__hero">
        <img class="container__hero__image" src="../assets/hero-background.jpg" alt="Image of a laptop" />
        <img class="container__hero__mobile-image" src="../assets/mobile1.jpg" alt="Image of a laptop" />
        <div class="container__hero__text">
          <h1>Your Digital Handyman</h1>
          <p>Digital products with human insight</p>
        </div>
      </div>
    </header>
    <p class="container__section-headline">My Projects</p>
 <Projects id="projects" />
 <About id="about"/>
 <Contact id="contact" />
 </div>
</template>

<script>
import About from '@/components/About'
import Projects from '@/components/Projects'
import Contact from '@/components/Contact'
export default {
  name: "Index",
  data() {
    return {};
  },
  components: {
    About,
    Projects,
    Contact
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "~@/assets/styles/main.scss";
</style>



// WEBPACK FOOTER //
// src/components/Index.vue